export default __webpack_public_path__ + "static/benifitImage2-f4195bda858e3b52b7756acf9ef008c3.png";